export default "__VITE_ASSET__b30ac8d6__"